/**
 * @generated SignedSource<<b631295a920c50c28b90f1c29a21e778>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type postMagazineConfigAppConfigQuery$variables = Record<PropertyKey, never>;
export type postMagazineConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type postMagazineConfigAppConfigQuery = {
  response: postMagazineConfigAppConfigQuery$data;
  variables: postMagazineConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "post_magazine"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "postMagazineConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"post_magazine\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "postMagazineConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"post_magazine\"})"
      }
    ]
  },
  "params": {
    "cacheID": "7a42bf4b26bf55671976b8801b8e5d66",
    "id": null,
    "metadata": {},
    "name": "postMagazineConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query postMagazineConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"post_magazine\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "43f37421dc64a7bb998ae28462f6026b";

export default node;
